<template>
  <div class="shop-store-container">
    <!-- 顶部选项卡 -->
    <div class="tab-container" :class="{ 'global-loading-active': globalLoading }">
      <el-tabs v-model="activeTab" type="border-card" @tab-click="handleTabChange">
        <el-tab-pane name="western">
          <span slot="label"><i class="el-icon-yl"></i> 西药房入库</span>
          <!-- 简化条件渲染 -->
          <western 
            v-show="activeTab === 'western' && !globalLoading"
            ref="westernComponent"
            @refresh="handleRefresh"
            @operation="handleChildOperation"
          />
        </el-tab-pane>
        <el-tab-pane name="traMedici">
          <span slot="label"><i class="el-icon-kangjunyaofei"></i> 中药房入库</span>
          <traMedici
            v-show="activeTab === 'traMedici' && !globalLoading"
            ref="traMediciComponent"
            @refresh="handleRefresh"
            @operation="handleChildOperation"
          />
        </el-tab-pane>
      </el-tabs>
      
      <!-- 全局Loading遮罩 - 优化显示条件 -->
      <div v-if="globalLoading" class="global-loading-mask">
        <div class="loading-content">
          <i class="el-icon-loading"></i>
          <p>正在加载采购入库单数据，请稍候...</p>
          <!-- 添加进度提示 -->
          <div class="loading-progress">加载中...</div>
        </div>
      </div>
      
      <!-- 添加加载状态下的占位内容 -->
      <div v-if="globalLoading" class="loading-placeholder">
        <div class="placeholder-content">
          <i class="el-icon-loading"></i>
          <span>正在准备采购入库单...</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Western from './Western/Western.vue';
import traMedici from './traMedici/traMedici.vue';
export default {
  name: 'ShopStore',
  components: {
    Western,traMedici
  },
  data() {
    return {
      activeTab: 'western',
		currentWarehouse: 3,
		globalLoading: false,
		fromPurchasePlan: false // 是否从采购计划跳转过来
    }
  },
  // 添加生命周期钩子
    mounted() {
      this.checkPurchasePlanRedirect();
    },
// 添加监听器，确保在activeTab变化时也能检查跳转
  watch: {
    activeTab: {
      immediate: true,
      handler(newTab) {
        this.$nextTick(() => {
          this.checkPurchasePlanRedirect();
        });
      }
    }
  },
  methods: {
	// 检查是否从采购计划跳转过来
	    checkPurchasePlanRedirect() {
	      const planData = sessionStorage.getItem('fromPurchasePlan');
	      if (planData) {
	        try {
	          const planInfo = JSON.parse(planData);
	          this.fromPurchasePlan = true;
	          
	          // 设置全局loading
	          this.globalLoading = true;
	          
	          // 2.8秒后关闭loading并打开采购入库单模态框
	          setTimeout(() => {
	            this.globalLoading = false;
	            this.openPurchaseOrderModal(planInfo);
	            
	            // 清理sessionStorage
	            sessionStorage.removeItem('fromPurchasePlan');
	          }, 2800);
	          
	        } catch (error) {
	          console.error('解析采购计划跳转数据失败:', error);
	          this.globalLoading = false;
	          sessionStorage.removeItem('fromPurchasePlan');
	        }
	      }
	    },
	// 打开采购入库单模态框
	    openPurchaseOrderModal(planInfo) {
	      this.$nextTick(() => {
	        if (this.$refs.westernComponent && this.activeTab === 'western') {
	          // 调用子组件的打开模态框方法
	          this.$refs.westernComponent.openPurchaseOrderFromPlan(planInfo);
	        } else if (this.$refs.traMediciComponent && this.activeTab === 'traMedici') {
	          this.$refs.traMediciComponent.openPurchaseOrderFromPlan(planInfo);
	        }
	      });
	    },
    handleTabChange(tab) {
          this.activeTab = tab.name;
          if (tab.name === 'western') {
            this.currentWarehouse = 3;
          } else if (tab.name === 'traMedici') {
            this.currentWarehouse = 4;
          }
          
          this.$nextTick(() => {
            if (this.$refs.westernComponent) {
              this.$refs.westernComponent.handleWarehouseChange(this.currentWarehouse);
            }
          });
        },
    
    handleRefresh() {
      // console.log('收到子组件刷新请求');
    },
    
    handleChildOperation(operation, data) {
      // console.log('收到子组件操作:', operation, data);
    }
  }
}
</script>

<style lang="less" scoped>
.shop-store-container {
  background: #f5f7fa;
  min-height: 80vh;
  position: relative;
}

.tab-container {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: relative;
  min-height: 400px;
  
  /* 添加加载状态样式 */
  &.global-loading-active {
    /deep/ .el-tabs__content {
      opacity: 0.3;
      filter: blur(1px);
      transition: all 0.3s ease;
    }
  }
  
  /deep/ .el-tabs__header {
    margin: 0;
    border-bottom: 1px solid #e6e8eb;
  }
  
  /deep/ .el-tabs__item {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    font-weight: 500;
    color: #606266;
    
    &.is-active {
      color: #409EFF;
      background-color: #ecf5ff;
      border-bottom-color: #409EFF;
    }
  }
}

/* 全局Loading遮罩样式增强 */
.global-loading-mask {
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.98);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  border-radius: 0 0 4px 4px;
  animation: fadeIn 0.3s ease;
}

.loading-content {
  text-align: center;
  
  .el-icon-loading {
    font-size: 40px;
    color: #409EFF;
    margin-bottom: 16px;
    animation: rotating 2s linear infinite;
  }
  
  p {
    color: #606266;
    font-size: 14px;
    margin: 0 0 10px 0;
  }
  
  .loading-progress {
    color: #909399;
    font-size: 12px;
  }
}

/* 加载占位符 */
.loading-placeholder {
  position: absolute;
  top: 80px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9998;
  
  .placeholder-content {
    text-align: center;
    
    .el-icon-loading {
      font-size: 24px;
      color: #409EFF;
      margin-right: 8px;
      animation: rotating 2s linear infinite;
    }
    
    span {
      color: #909399;
      font-size: 14px;
    }
  }
}

/* 动画定义 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .tab-container {
    /deep/ .el-tabs__item {
      padding: 0 12px;
      font-size: 13px;
    }
  }
  
  .loading-content {
    .el-icon-loading {
      font-size: 32px;
    }
    
    p {
      font-size: 13px;
    }
  }
  
  .global-loading-mask {
    top: 40px;
  }
}
</style>